import { Component, Inject, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-print-receipt-modal',
	templateUrl: './print-receipt-modal.html'
})

export class PrintReceiptModalComponent implements OnInit {
	@ViewChildren('checkbox') public checkboxes: UntypedFormControl;
	public form: UntypedFormGroup;

	constructor(public dialogRef: MatDialogRef<PrintReceiptModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
				private _formBuilder: UntypedFormBuilder) {
	}

	close() {
		this.dialogRef.close();
	}

	ngOnInit(): void {
		this.form = this._formBuilder.group({
			hideStatusCodes: (localStorage.getItem('hideStatusCodes') == 'true'),
			hideParcelInfo: (localStorage.getItem('hideParcelInfo') == 'true'),
			hideRating: (localStorage.getItem('hideRating') == 'true'),
			hideSignature: (localStorage.getItem('hideSignature') == 'true'),
			hideDestinationAddress: (localStorage.getItem('hideDestinationAddress') == 'true'),
			hideOriginAddress: (localStorage.getItem('hideOriginAddress') == 'true')
		});
	}

	print() {
		this.setPrintSettings();
		this.close();
		setTimeout(() => {
			const printContents = document.getElementById('receipt').innerHTML;
			const tab: any = window.open('', '_blank');
			tab.document.open();
			tab.document.write('<html><head>');
			tab.document.write('<link rel="stylesheet" href="assets/stylesheets/print.css" media="print">');
			tab.document.write('</head><body>');
			tab.document.write(printContents);
			tab.document.write('</body></html>');
			tab.document.close();
			setTimeout(() => {
				tab.print();
			}, 500);
			return false;
		}, 0);
	}

	setPrintSettings() {
		localStorage.setItem('hideStatusCodes', this.form.get('hideStatusCodes').value);
		localStorage.setItem('hideParcelInfo', this.form.get('hideParcelInfo').value);
		localStorage.setItem('hideRating', this.form.get('hideRating').value);
		localStorage.setItem('hideSignature', this.form.get('hideSignature').value);
		localStorage.setItem('hideDestinationAddress', this.form.get('hideDestinationAddress').value);
		localStorage.setItem('hideOriginAddress', this.form.get('hideOriginAddress').value);
	}

}
